<template>
  <div id="vue-app-1">
    <NeighborhoodResources v-if="selectedTable === 'NeighborhoodResources'"/>
    <NACTable v-if="selectedTable === 'NAC'"/>
    <NECTable v-if="selectedTable === 'NEC'"/>
    <HCATable v-if="selectedTable === 'HCA'"/>
  </div>
</template>

<script>
import NACTable from './components/NACTable.vue'
import NECTable from './components/NECTable.vue'
import HCATable from './components/HCATable.vue'
import NeighborhoodResources from './components/NeighborhoodResources.vue'

export default {
  name: 'App',
  components: {
    NeighborhoodResources,
    NACTable,
    NECTable,
    HCATable,
  },
  data: function() {
    return {
      selectedTable:  process.env.VUE_APP_COMPONENT,
    };
  },
}
</script>

<style>
/* #vue-app-1 {
  width: 70rem;
  margin: 0 auto;
} */

thead tr th {
    width: 50%;
  }
</style>
